import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { ServiceSettingsComponent } from './service-settings.component';


const routes: Routes = [
  {
      path: '',
      component: ServiceSettingsComponent,
      canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceSettingsRoutingModule { }
